export default __webpack_public_path__ + "8f4ec2fedc82c112e4e819fb6feb7265.webp";